import { useMemo } from 'react'
import { useReceptors } from 'src/pages/Receptors/receptors.hooks'
import { GRC_RECEPTOR_MODEL_IDS } from 'src/pages/Receptors/receptors.constants'
import { CitationUrlOptions } from './ActivitiesPage.constants'

/**
 * The account-specific context getCitationUrl needs: a receptor citation only carries the
 * receptor id, so the account's receptors tell us which ids are GRC platforms.
 */
export const useCitationUrlOptions = (): CitationUrlOptions => {
  const { data } = useReceptors()
  return useMemo(() => {
    const grcReceptorIds = new Set<string>()
    data?.getReceptorsList().forEach((receptor) => {
      if (GRC_RECEPTOR_MODEL_IDS.includes(receptor.getModelid())) {
        grcReceptorIds.add(receptor.getId())
      }
    })
    return { grcReceptorIds }
  }, [data])
}
